<template>
  <div>
    <cx-select
      v-if="provinceData.length"
      @change="changeProvince"
      :value="province"
      :selectOptions="provinceData"
      title="省"
      titleSize="16%"
    />
    <cx-select
      class="mt16"
      v-if="province.length && province !== '全国'"
      @change="changeCity"
      :value="city"
      :selectOptions="cityData"
      title="市"
      titleSize="16%"
    />
    <cx-select
      class="mt16"
      v-if="city.length && options.chartOption.name.split('/').length > 2"
      @change="changeArea"
      :value="area"
      :selectOptions="areaData"
      title="区/县"
      titleSize="16%"
    />
    <div v-show="this.chartOption.name === '全国'" class="flex_input">
      <div class="number_title mr16">经度</div>
      <single-input
        class="number_input"
        :value.sync="mapX"
        :noInputSuffixs="true"
      />
<!--      <el-input-->
<!--        v-model="mapX"-->
<!--        placeholder="请输入"-->
<!--        type="number"-->
<!--        class="number_input"-->
<!--        v-inputHandle="{ this1, type: 'mapX' }"-->
<!--      ></el-input>-->
    </div>
    <div v-show="this.chartOption.name === '全国'" class="flex_input">
      <div class="number_title mr16">纬度</div>
      <single-input
        class="number_input"
        :value.sync="mapY"
        :noInputSuffixs="true"
      />
<!--      <el-input-->
<!--        v-model="mapY"-->
<!--        placeholder="请输入"-->
<!--        type="number"-->
<!--        class="number_input"-->
<!--        v-inputHandle="{ this1, type: 'mapY' }"-->
<!--      ></el-input>-->
    </div>
    <div class="flex_input">
      <slider-and-input :value.sync="mapScale" title="缩放" :sliderMax="36" suffix="倍" :sliderMin="0" className="scale-input" class="scale-slider-input"/>
    </div>
    <div class="flex_input">
      <slider-and-input :value.sync="opacity" suffix="倍" title="透明度" :sliderMin="0" :sliderMax="100"  className="scale-input" class="scale-slider-input"/>
    </div>
    <div class="flex_input">
      <div  class="number_title mr16">交互</div>
      <div>
        <cx-check-box :value.sync="startDeep">开启地图下钻</cx-check-box>
        <cx-check-box class="mt16" :value.sync="canwheelScale">开启鼠标滚轮缩放</cx-check-box>
        <cx-check-box class="mt16" :value.sync="canDrag">开启鼠标左键拖拽</cx-check-box>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "global-setting",
  props: { options: Object },
  data() {
    return {
      provinceData: [],
      cityData: [],
      areaData: [],
      pcaCode: null,
      this1: this
    }
  },

  methods: {
    initProvinceData() {
      const _provinceData = []
      this.pcaCode.forEach(province => {
        _provinceData.push({ value: province.code, label: province.name })
        this.provinceData = _provinceData
      })
    },
    initCitysData(name) {
      if (name === "" || name === "全国") return
      const _cityData = []
      let citys = this.pcaCode.find(province => province.name === name.split("/")[0])
      if (citys && citys.children.length === 1) {
        //直辖市没有更下一级 所以直接获取下一级
        citys = citys.children[0]
      }
      citys.children.forEach(city => {
        _cityData.push({ value: city.code, label: city.name })
      })
      this.cityData = _cityData
    },
    initAreaData(name) {
      if (name.split("/").length < 3) return
      const province = this.pcaCode.find(province => province.name === this.province)
      const areas = province.children.find(city => city.name === name.split("/")[1])
      const res = []
      areas.children.forEach(area => {
        res.push({ value: area.code, label: area.name })
      })
      this.areaData = res
    },
    changeProvince(provinceCode) {
      if (!provinceCode) {
        this.$changeOptionsEV("全国", "chartOption.name", false)
      } else {
        const name = this.provinceData.find(item => item.value === provinceCode).label
        const jsonLocation = `${name}/${name}.${provinceCode + new Array(6 - provinceCode.length).fill(0).join("")}`
        this.$changeOptionsEV(jsonLocation, "chartOption.name", false)
      }
    },
    changeCity(cityCode) {
      let porvince = this.pcaCode.find(province => province.name === this.province)
      let specialProvince
      if (porvince.children.length === 1) {
        //处理直辖市
        specialProvince = 1
        porvince = porvince.children[0]
      }
      const city = porvince.children.find(city => city.code === cityCode)
      const jsonLocation = `${this.province}/${specialProvince ? "" : city.name + "/"}${city.name}.${
        city.code + new Array(6 - city.code.length).fill(0).join("")
      }`
      this.$changeOptionsEV(jsonLocation, "chartOption.name", false)
    },
    changeArea(areaCode) {
      const names = this.options.chartOption.name.split("/")
      const porvinces = this.pcaCode.find(porvince => porvince.name === names[0])
      const cities = porvinces.children.find(city => city.name === names[1])
      const area = cities.children.find(area => area.code === areaCode)
      const jsonLocation = `${porvinces.name}/${cities.name}/${area.name}.${area.code}`
      this.$changeOptionsEV(jsonLocation, "chartOption.name", false)
    }
  },
  computed: {
    opacity: {
      get() {
        return this.options.chartOption.geo3D.itemStyle.opacity * 100
      },
      set(value) {
        this.$changeOptionsEV(value / 100, "chartOption.geo3D.itemStyle.opacity", false)
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    mapScale: {
      get() {
        return (400 - this.options.chartOption.geo3D.viewControl.distance) / 10
      },
      set(newValue) {
        this.$changeOptionsEV((40 - newValue)*10, "chartOption.geo3D.viewControl.distance", false)
      }
    },
    mapX: {
      get() {
        return this.chartOption.center[0]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.center.0", false)
      }
    },
    mapY: {
      get() {
        return this.chartOption.center[1]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.center.1", false)
      }
    },
    startDeep: {
      get() {
        return this.options.chartOption.deepMap
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.deepMap", false)
      }
    },
    canDrag: {
      get() {
        return !!this.options.chartOption.geo3D.viewControl.rotateSensitivity
      },
      set(val) {
        this.$changeOptionsEV(+val, "chartOption.geo3D.viewControl.rotateSensitivity", false)
      }
    },
    canwheelScale: {
      get() {
        return !!this.options.chartOption.geo3D.viewControl.zoomSensitivity
      },
      set(val) {
        this.$changeOptionsEV(+val, "chartOption.geo3D.viewControl.zoomSensitivity", false)
      }
    },
    country() {
      return this.options.chartOption.name.split("/")[0]
    },
    province() {
      const nameList = this.options.chartOption.name.split("/")
      const province = nameList.length > 1 ? nameList[0].split(".")[0] : "全国"
      this.initCitysData(this.options.chartOption.name)
      return province
    },
    city() {
      this.initAreaData(this.options.chartOption.name)
      const nameList = this.options.chartOption.name.split("/")
      if (nameList.length > 1) {
        const cityName = nameList[1].split(".")[0]
        if (cityName === this.province) {
          return ""
        } else return cityName
      } else return ""
    },
    area() {
      const nameList = this.options.chartOption.name.split("/")
      if (nameList.length === 3 && nameList[1] !== nameList[2].split(".")[0]) {
        return nameList[2].split(".")[0]
      } else return ""
    }
  },
  created() {
    if (localStorage.getItem("pca-code")) {
      this.pcaCode = JSON.parse(localStorage.getItem("pca-code"))
      this.initProvinceData()
    } else {
      this.instance.get("sv2/assets/map/pca-code.json").then(res => {
        const data = res.data
        this.pcaCode = data
        window.localStorage.setItem("pca-code", JSON.stringify(data))
        this.initProvinceData()
      })
    }
  }
}
</script>

<style scoped>
.flex_input {
  display: flex;
  margin-top: 16px;
}
.number_title {
  width: 17%;
  font-size: 14px;
  color: var(--textColor) !important;
}
.number_input {
  width: 80%;
}
.scale-slider-input/deep/ .scale-input {
  width: 19%;
}
</style>
